import { verify, resendCode } from 'util/api'
import { useDocTitle } from 'util/hooks'

import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import 'css/pages/verification.css'
import { showToast } from 'components/toast'

export const Verification = () => {
	const searchParams = new URLSearchParams(window.location.search)
	const email = searchParams.get('email')
	const navigate = useNavigate()

	const [ code, setCode ] = useState()

	const onCodeBlur = ({ target }) => {
		setCode(target.value)

		if (
			target.value.match(/\d{6}/)
		) {
			target.setCustomValidity('')
			return
		}
		
		target.setCustomValidity(
			'The pin should be a 6-digit number.'
		)
	}

	const onFormSubmit = async event => {
		event.preventDefault()

		const response = await verify(
			email,
			code,
		)

		if (response.status === 200) {
			navigate('/login')
			return
		}

		showToast("The verification code was not accepted. Please try again.")
	}

	const onResendLinkClick = async () => {
		const response = await resendCode(email)

		if (response.status === 200) {
			showToast(`A new code has been sent to ${email}`, "success")
			return
		}

		showToast("Something went wrong. Please try again.")
	}

	useDocTitle('All for One - Verification Code')

	return (
		<section className="verification-container">
			<h1 className="verification-header">Enter <span className="highlight">verification code</span></h1>

			<p className="verification-note">
				You’ll get an email at {email} if it’s linked to your account.
			</p>

			<form
				id="verification-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<div className="form-group">
					<input 
						type="tel" 
						id="code" 
						name="code" 
						placeholder="6-digit code" 
						required
						onBlur={onCodeBlur}
					/>
				</div>

				<div className="form-group">
					<button type="submit" className="verification-btn">Next</button>
				</div>
			</form>

			<p className="additional-links">
				Did not receive the email? Check your spam filter or 
				<Link
					to={window.location}
					id="resend-link"
					onClick={onResendLinkClick}
				>
					Resend code
				</Link>
			</p>

			<p className="login-prompt">
				Remembered your password? <Link to="/login" className="login-link">Log in!</Link>
			</p>
		</section>
	)
}
